import { Link } from 'react-router-dom'
import './Hero.scss'

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-left">
        <div className="hero-eyebrow">Fabricat artizanal în România</div>
        <h1 className="hero-title">
          Arome<br />
          <em>delicate</em><br />
          pentru acasă
        </h1>
        <p className="hero-sub">
          Lumânări și odorizante din ceară naturală de soia, decorate cu flori
          uscate. Fiecare piesă este creată manual cu grijă și dragoste.
        </p>
        <div className="hero-btns">
          <Link to="/shop" className="btn-primary">Descoperă colecția</Link>
          <a href="#despre" className="btn-ghost">Povestea noastră</a>
        </div>
        <div className="hero-badge">
          <div className="hero-badge-text">100%<br />Natural<br />★★★★★</div>
        </div>
      </div>

      <div className="hero-right">
        <div className="product-card-float card-main">
          <img
            src="/hero-product-large.png"
            alt="Sachet floral din ceară naturală, decorat cu flori uscate"
            className="hero-product-img"
            width={380}
            height={480}
            decoding="async"
          />
        </div>
        <div className="product-card-float card-sm">
          <img
            src="/hero-product-small.png"
            alt="Sachet oval din ceară, cu flori presate"
            className="hero-product-img"
            width={240}
            height={280}
            decoding="async"
          />
        </div>
      </div>
    </section>
  )
}
